import React, { Component } from "react";
import ItemInfoAdderPanelView from "presentational/upload/ItemInfoAdderPanelView/ItemInfoAdderPanelView";
import PropTypes from "prop-types";

class ItemInfoAdderPanel extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    itemInfo: PropTypes.shape({
      category: PropTypes.string.isRequired,
      brand: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired
    }).isRequired,
    onInfoChange: PropTypes.func.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired
  };

  render() {
    const {
      imageDataURL,
      itemInfo,
      onInfoChange,
      onBackClick,
      onNextClick
    } = this.props;

    return (
      <ItemInfoAdderPanelView
        imageDataURL={imageDataURL}
        itemInfo={itemInfo}
        onInfoChange={onInfoChange}
        onBackClick={onBackClick}
        onNextClick={onNextClick}
      />
    );
  }
}

export default ItemInfoAdderPanel;
